import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { BooleanInput, ReferenceInput, SelectInput, TextInput } from 'react-admin';
import { required } from 'react-admin';
import { FormDataConsumer } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import isBlank from '../../../Common/Utils/Blank';
import DateField from '../../../Common/Utils/DateField';
import isPresent from '../../../Common/Utils/Present';
import Targets from './Targets';
import PlacementPreviewButton from '../Helpers/PlacementPreviewButton';

const ValidateRequired = required();

const styles = createStyles({
  exampleUrl: {
    width: '90%'
  }
});

type Props = {
  classes: any,
  record: any,
  resource: string
};

const SettingsTab = (props: Props) => (
  <div>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 2, paddingRight: 30 }}>
        <FormDataConsumer>
          {({ formData, ...rest }) => formData && formData.code &&
            <span><br />ID: {formData.code}<br /></span>
          }
        </FormDataConsumer>
        <Field
          component={BooleanInput}
          label="Active"
          name="active"
          source="active"
          style={{ width: '0' }} />
        <Field
          component={TextInput}
          label="Placement Name *"
          name="name"
          options={{ fullWidth: true }}
          source="name"
          validate={ValidateRequired} /><br />
        <Field
          component={TextInput}
          label="Global Account *"
          name="account"
          options={{ fullWidth: true }}
          source="account"
          validate={ValidateRequired} /><br /><br />

        <FieldArray name="targets" component={Targets} label="Global Targeting" />
      </div>
      <div style={{ flex: 1 }}>
        <Field name="site" source="site" component={ReferenceInput} label="Site *" resource={props.resource} reference="helpers/sites" sort={{ field: 'name', order: 'ASC' }} allowEmpty record={props.record}>
          <Field name="site" source="site" component={SelectInput} validate={ValidateRequired} />
        </Field>

        <Field
          component={BooleanInput}
          label="Enable Single Request"
          name="enable_single_request"
          source="enable_single_request"
          style={{ width: '190px' }} />
        {isBlank(props.record.id) && <Field
          component={BooleanInput}
          label="Bordeaux Placement"
          name="bordeaux"
          options={{ disabled: isPresent(props.record) }}
          source="bordeaux"
          style={{ width: '190px' }} />}
        {props.record && props.record.bordeaux && <div style={{ color: 'gray', paddingTop: 10 }}>Bordeaux Placement<br /></div>}
      </div>
    </div>
    <div style={{ display: 'flex' }}>
      <div style={{ flex: 2, paddingRight: 30 }}>
        <Field
          className={props.classes.exampleUrl}
          component={TextInput}
          label="Example URL (Also used for Placement Preview button)"
          name="example_url"
          source="example_url" /><br /><br />
      </div>
      <div style={{ flex: 1 }}>
        <PlacementPreviewButton record={props.record} />
      </div>
    </div>
    <span style={{ color: 'rgba(0, 0, 0, 0.298039)' }}>
      Created <DateField label="Date" name="created_at" record={props.record} />
    </span>
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/SettingsTab.tsx